import { IntakeMessageTypeEnum } from 'APP/Services/Mattermost/types'

export const isPostTypePromptFile = (post: any) => {
  if (!post || !post.props) {
    return false
  }
  return post.props?.type === IntakeMessageTypeEnum.prompt_file
}
